import Accordion from "@resources/js/ui/Accordion";

new Accordion('.js-faq-accordion-item', { behavior: 'smooth' })
